import { inject, Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { DangerError } from "@shared/errors/custom.error";

/*  
----------------------------------------------------------
Generación de documentos pdf de resoluciones y ordinarios 
del expediente.
----------------------------------------------------------
*/
@Injectable({
    providedIn: "root",
})
export class GeneradorPdfService {

    private readonly apiService = inject(ApiService);

    async generarPdf(
        expedienteId: number,
        templateId: number,
        rut: number
    ) {
        const payload = {
            expediente: expedienteId,
            template: templateId,
            rut: rut
        };

        const { msg, success, data } = await this.apiService.privatePost<any>(
            `generador-pdf`,
            payload
        );

        if (!success) throw new DangerError(msg);

        return data;
    }
}